import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SERVICE_CONFIG_TOKEN, ServiceConfig } from '@web/csl-lib-services';

@Injectable({
  providedIn: 'root'
})
export class MetaService {

  private serviceConfig: ServiceConfig;
  private http!: HttpClient;
  private readonly apiUrl! : string;

  constructor() {
    this.http = inject(HttpClient);
    this.serviceConfig = inject(SERVICE_CONFIG_TOKEN);
    this.apiUrl = this.serviceConfig.apiUrl;
  }

  getApiVersion() : Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/meta/apiVersion`);
  }

  getDbVersion() : Observable<string> {
    return this.http.get<string>(`${this.apiUrl}/meta/dbVersion`);
  }


}
